import { useState } from 'react'

const sizes = ['text-sm', 'text-base', 'text-lg', 'text-xl', 'text-2xl', 'text-3xl'] as const

/** A−/A+ control for the transcript text size. Starts at text-lg. */
export function useFontSize() {
  const [index, setIndex] = useState(2)

  const fontSizeUI = (
    <div className="inline-flex overflow-hidden rounded-xl border-2 border-qt-line" role="group" aria-label="Transcript text size">
      <button type="button" aria-label="Smaller text" onClick={() => setIndex((i) => Math.max(0, i - 1))} className="px-3 py-1.5 text-sm font-bold hover:bg-qt-soft">
        A−
      </button>
      <button
        type="button"
        aria-label="Larger text"
        onClick={() => setIndex((i) => Math.min(sizes.length - 1, i + 1))}
        className="border-l-2 border-qt-line px-3 py-1.5 text-lg font-bold hover:bg-qt-soft"
      >
        A+
      </button>
    </div>
  )

  return { fontSizeUI, fontSizeClass: sizes[index] }
}
